import React from 'react';

export default props => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M8 42V18L24 6L40 18V42H8Z" fill="#268AE6" />
        <path
            d="M17.5001 34.15H26.4001C26.8818 34.15 27.2855 33.9871 27.6113 33.6612C27.9372 33.3354 28.1001 32.9317 28.1001 32.45V29.75L32.2001 31.9V24.25L28.1001 26.4V23.7C28.1001 23.2183 27.9372 22.8146 27.6113 22.4888C27.2855 22.1629 26.8818 22 26.4001 22H17.5001C17.0326 22 16.6407 22.1629 16.3244 22.4888C16.0082 22.8146 15.8501 23.2183 15.8501 23.7V32.45C15.8501 32.9317 16.0082 33.3354 16.3244 33.6612C16.6407 33.9871 17.0326 34.15 17.5001 34.15Z"
            fill="white"
        />
    </svg>
);
